module.exports = __webpack_public_path__ + "img/webguide.e2ea3c42.svg";